export default __webpack_public_path__ + "static/media/GraphikLCWeb-Medium.c711dd86.woff";